import React from "react";

export const TENDERING_CREATE_STEPS = {
  SELECT: 1,
  INFO: 2,
  IMAGES: 3,
  DOCUMENTS: 4,
  SUMMARY: 5,
};

const CreateTenderingContext = React.createContext({
  step: 1,
  goForward: () => {},
  goBack: () => {},
  details: {},
  setDetails: () => {},
  onSuccess: (id) => {},
});

export default CreateTenderingContext;
